import { render, staticRenderFns } from "./buttons.vue?vue&type=template&id=9f93089e"
import script from "./buttons.vue?vue&type=script&lang=js"
export * from "./buttons.vue?vue&type=script&lang=js"
import style0 from "./buttons.vue?vue&type=style&index=0&id=9f93089e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports